export default __webpack_public_path__ + "static/media/metamask-setup_image_4.73afa21d.jpg";